import { render, staticRenderFns } from "./RecentPageTile.vue?vue&type=template&id=3593a252&scoped=true"
import script from "./RecentPageTile.vue?vue&type=script&lang=js"
export * from "./RecentPageTile.vue?vue&type=script&lang=js"
import style0 from "./RecentPageTile.vue?vue&type=style&index=0&id=3593a252&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3593a252",
  null
  
)

export default component.exports